import { isObjectFitSupported, libInit, sendGoogleEvent } from '@html/_common/utils';

const EVENT_CATEGORY = 'CLP - ';

export default function AOClpHighlightsGallery() {
  const sections = [];

  const onImageLoad = (section, src, srcSet, alt) => {
    section.$clonedBackgroundImage.toggleClass('ao-clp-highlights-gallery__image--fade', true);
    section.timeoutId = setTimeout(() => {
      section.$clonedBackgroundImage.attr('src', src).attr('srcset', srcSet).attr('alt', alt);
    }, 500);
  };

  const onClickArrow = (event) => {
    const $element = $(event.currentTarget);
    const shift = $element.data('shift');
    const sectionId = $element.data('sectionId');
    const section = sections[sectionId];

    if ((shift < 0 && section.currentIndex > 0)
              || (shift > 0 && section.currentIndex < section.size - 1)) {
      const $currentHighlight = $(section.$highlights[section.currentIndex]);
      const $nextHighlight = $(section.$highlights[section.currentIndex + shift]);
      const translateX = `translateX(${-100 * (section.currentIndex + shift)}%)`;

      $currentHighlight.css('transform', translateX).css('-webkit-transform', translateX).toggleClass('ao-clp-highlights-gallery__highlight--active', false);
      $nextHighlight.css('transform', translateX).css('-webkit-transform', translateX).toggleClass('ao-clp-highlights-gallery__highlight--active', true);

      section.currentIndex += shift;

      if (section.currentIndex === 0) {
        section.$arrowLeft.toggleClass('hid', true);
      } else if (section.currentIndex > 0) {
        section.$arrowLeft.toggleClass('hid', false);
      }

      if (section.currentIndex === section.size - 1) {
        section.$arrowRight.toggleClass('hid', true);
      } else if (section.currentIndex < section.size - 1) {
        section.$arrowRight.toggleClass('hid', false);
      }

      section.$indicators.toggleClass('ao-clp-highlights-gallery__indicator--active', false);
      $(section.$indicators[section.currentIndex]).toggleClass('ao-clp-highlights-gallery__indicator--active', true);

      const src = $nextHighlight.data('src');
      if (isObjectFitSupported()) {
        if (section.timeoutId) clearTimeout(section.timeoutId);

        const alt = $nextHighlight.data('alt');
        const srcSet = $nextHighlight.data('srcset');

        section.$backgroundImage.off('load');
        section.$clonedBackgroundImage.toggleClass('ao-clp-highlights-gallery__image--fade', false);

        section.$backgroundImage.attr('src', src);
        section.$backgroundImage.attr('srcset', srcSet);
        section.$backgroundImage.attr('alt', alt);

        section.$backgroundImage.on('load', () => onImageLoad(section, src, srcSet, alt));
      } else {
        section.$sectionElement.attr('style', `background-image:url('${src}')`);
      }

      sendGoogleEvent(`${EVENT_CATEGORY}Highlights Gallery`, 'Click', 'Change');
    }
  };

  const initiateSection = (index, element) => {
    const $sectionElement = $(element);
    const section = {};

    section.index = sections.length;
    section.$sectionElement = $sectionElement;
    section.$highlights = $sectionElement.find('.js-ao-clp-highlights-gallery__highlight');
    section.currentIndex = 0;
    section.size = section.$highlights.length;
    section.$arrowLeft = $sectionElement.find('.js-ao-clp-highlights-gallery__arrow--left');
    section.$arrowRight = $sectionElement.find('.js-ao-clp-highlights-gallery__arrow--right');
    section.$indicators = $sectionElement.find('.js-ao-clp-highlights-gallery__indicators').children();

    if (isObjectFitSupported()) {
      section.$backgroundImage = section.$sectionElement.find('.js-ao-clp-highlights-gallery__image');
      section.$clonedBackgroundImage = section.$sectionElement.find('.js-ao-clp-highlights-gallery__image--cloned');
    }

    if (section.$highlights.length > 2) {
      section.$highlights.each((highlightIndex, highlight) => {
        if (highlightIndex >= 2) {
          const translateX = `translateX(${-100 * (index - 1)}%)`;
          $(highlight).css('transform', translateX).css('-webkit-transform', translateX);
        }
      });
    }

    if (section.size === 1) section.$arrowRight.toggleClass('hid', true);

    section.$arrowRight.data('sectionId', section.index);
    section.$arrowRight.click(onClickArrow);

    section.$arrowLeft.data('sectionId', section.index);
    section.$arrowLeft.click(onClickArrow);

    section.$highlights.swipeLeft(section.$arrowRight.click);

    section.$highlights.swipeRight(section.$arrowLeft.click);

    sections.push(section);
  };

  const initiate = () => {
    const $sections = $('.js-ao-clp-highlights-gallery');

    if ($sections.length > 0) libInit('touch', () => $sections.each(initiateSection));
  };

  return { initiate };
}
